import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import qs from "query-string";

import "./Login.css";
import config from "../constants/config";
import { validateThenLogin } from "../actions/auth";
import { LoginInput, PasswordInput, CheckBox } from "../components/Input";
import SignInButton from "../components/Buttons/SignInButton";
import WhiteLoginButton from "../components/Buttons/WhiteLoginButton";
import OrDivider from "../components/Divider/OrDivider";
import GoogleLoginButton from "../components/Buttons/GoogleLoginButton";

class CreateAccount extends React.Component {
  state = { name: "", email: "", password: "", isMerchant: false };

  googleLogin = () => {
    const link = `${config.API_ENDPOINT}/auth/google`;
    window.location.href = link;
  };

  localLogin = async () => {
    const { name, email, password, isMerchant } = this.state;

    // validate fields
    if (
      email === "" ||
      password === "" ||
      (name === "" && !this.props.loginModal)
    ) {
      return this.setState({ loginErr: "One of the above fields is empty" });
    } else if (this.props.auth.error) {
      console.log(this.props.auth.error);
      return this.setState({ loginErr: "Server error" });
    }

    // try login
    const res = await fetch(
      `${config.API_ENDPOINT}/auth/local${
        this.props.loginModal ? "" : "/create"
      }?${qs.stringify({
        name,
        email,
        password,
        isMerchant
      })}`
    )
      .then(resp => {
        if (resp.ok) return resp.json();
        else console.log("error logging in");
      })
      .catch(err => console.log(err));

    if (res && res.status >= 400) {
      this.setState({ loginErr: res.message });
    } else {
      // update redux
      this.props.validateThenLogin(res.token);
    }
  };

  onInputChange = (field, value) => {
    const newState = { [field]: value };
    if (this.state.loginErr && value !== "") newState.loginErr = undefined;

    this.setState(newState);
  };

  render() {
    return (
      <div className="backgroundDiv">
        {/* placeholder div */}
        <div style={{ minHeight: 90 }} />

        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}
        >
          <form onSubmit={e => e.preventDefault()}>
            <LoginInput
              type="text"
              placeholder="Your name"
              autoComplete="name"
              onChange={event => this.onInputChange("name", event.target.value)}
              value={this.state.name}
            />
            <LoginInput
              type="email"
              placeholder="Your email"
              autoComplete="username email"
              onChange={event =>
                this.onInputChange("email", event.target.value)
              }
              value={this.state.email}
            />
            <PasswordInput
              placeholder="Your password"
              autoComplete="password"
              onChange={event =>
                this.onInputChange("password", event.target.value)
              }
              value={this.state.password}
              showEmojiMeter={true}
            />
            <CheckBox
              label="Are you a merchant?"
              checked={this.state.isMerchant}
              onChange={e => this.setState({ isMerchant: e.target.checked })}
            />

            {this.state.loginErr && (
              <p style={{ textAlign: "center", color: "red", margin: 0 }}>
                {this.state.loginErr}
              </p>
            )}

            <SignInButton onClick={this.localLogin} text="CREATE ACCOUNT" />
          </form>
          {!this.state.isMerchant && (
            <div>
              <OrDivider />
              <GoogleLoginButton onClick={this.googleLogin} />
            </div>
          )}
        </div>

        <div style={{ width: "100%", padding: 20, textAlign: "center" }}>
          <WhiteLoginButton title="ALREADY HAVE AN ACCOUNT?" to="/" />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  validateThenLogin: token => dispatch(validateThenLogin(token))
});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateAccount));
